import React from 'react'
import { l } from '@manychat/manyui'

import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { ConditionText } from 'common/builder/components/chart/FlowChart/components/Node/Condition/ConditionText'
import { FlowChartConditionGroup } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'

import * as styles from './ConditionGroup.styles'

interface ConditionGroupProps {
  conditionGroup: FlowChartConditionGroup
  isLast: boolean
}

export const ConditionGroup = ({
  conditionGroup: { nextStep, conditions },
  isLast,
}: ConditionGroupProps) => {
  return (
    <>
      <view style={styles.ConditionGroupWrapperStyle}>
        <view style={styles.ConditionListWrapperStyle}>
          {conditions.length === 0 && (
            <richtext
              style={styles.EmptyConditionsLabelStyle}
              text={l.translate('Add condition')}
            />
          )}

          <view style={styles.ConditionListStyle}>
            {conditions.map((condition, index) => (
              <ConditionText key={index} condition={condition} />
            ))}
          </view>
        </view>
        <NextStep nextStep={nextStep} style={styles.NextStepStyle} />
      </view>
      <view style={isLast ? styles.BorderBottomLastStyle : styles.BorderBottomStyle} />
    </>
  )
}
